export default __webpack_public_path__ + "src/images/time_font-d37589.png";